/**
 * Session-expiry signal. The low-level HTTP layer calls `notifySessionExpired()`
 * when it hits a 401 it can't refresh away (token missing/expired). The auth
 * store registers a handler that drops the session and bounces to /login. Kept
 * in its own module so http.ts never imports the auth store (avoids a cycle).
 */
let handler: (() => void) | null = null;

export function setOnSessionExpired(fn: () => void): void {
  handler = fn;
}

export function notifySessionExpired(): void {
  handler?.();
}
